import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    gifts: [],
  },
  mutations: {
    setGifts(state, gifts) {
      Vue.set(state, 'gifts', gifts);
    },
  },
  actions: {
    fetchGifts({ commit, rootState }) {
      return this.$axios.get(`${rootState.endpoints.filings}/${rootState.filing.currentFilingId}/gifts`).then(response => {
        return commit('setGifts', response.data);
      }).catch(error => {
        return error.message;
      });
    },
  },
};